import { render, staticRenderFns } from "./classroom.vue?vue&type=template&id=08e2423e&scoped=true"
import script from "./classroom.vue?vue&type=script&lang=js"
export * from "./classroom.vue?vue&type=script&lang=js"
import style0 from "./classroom.vue?vue&type=style&index=0&id=08e2423e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e2423e",
  null
  
)

export default component.exports